<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateUniversity)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Program - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Program Name</label>
                  <md-input v-model="name" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="university"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>University</label>
                  <md-select v-model="university" name="university">
                    <md-option value="">Select University</md-option>
                    <md-option
                      v-for="c in universities"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="application_autumn_start_date"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="application_autumn_start_date"
                  md-immediately
                >
                  <label>Application Fall Start Date</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="application_autumn_end_date"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="application_autumn_end_date"
                  md-immediately
                >
                  <label>Application Fall End Date</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="application_spring_start_date"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="application_spring_start_date"
                  md-immediately
                >
                  <label>Application Spring Start Date</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="application_end_date"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="application_spring_end_date"
                  md-immediately
                >
                  <label>Application Spring End Date</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="lesson_start_date"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="lesson_start_date"
                  md-immediately
                >
                  <label>Lesson Start Date</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="type"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Type</label>
                  <md-select v-model="type" name="type">
                    <md-option value="">Select University</md-option>
                    <md-option value="1">Associate degree</md-option>
                    <md-option value="2">Bachelor degree</md-option>
                    <md-option value="3">Master Non-Thesis</md-option>
                    <md-option value="4">Master With Thesis</md-option>
                    <md-option value="5">Phd degree</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="price"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Price</label>
                  <md-input v-model="price" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="discounted_price"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Discounted Price</label>
                  <md-input v-model="discounted_price" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="commission"
                rules="numeric"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>%</md-icon>
                  <label>Commission</label>
                  <md-input v-model="commission" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="fix_commission_price"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Fix Commission Price</label>
                  <md-input v-model="fix_commission_price" type="text">
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="student_fix_commission_price"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Student Fix Commission Price</label>
                  <md-input v-model="student_fix_commission_price" type="text">
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="currency"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>article</md-icon>
                  <label>Currency</label>
                  <md-select v-model="currency" name="scope">
                    <md-option value="">Select Scope</md-option>
                    <md-option value="TRY">Turkish Lira</md-option>
                    <md-option value="USD">US Dollar</md-option>
                    <md-option value="EUR">Euro</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="turkish_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Turkish Preparation Price</label>
                  <md-input v-model="turkish_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="english_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>English Preparation Price</label>
                  <md-input v-model="english_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="german_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>German Preparation Price</label>
                  <md-input v-model="german_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="arabic_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Arabic Preparation Price</label>
                  <md-input v-model="arabic_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="french_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>French Preparation Price</label>
                  <md-input v-model="french_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="russian_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Russian Preparation Price</label>
                  <md-input v-model="russian_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="spanish_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Spanish Preparation Price</label>
                  <md-input v-model="spanish_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-25 md-small-size-100">
              <ValidationProvider name="chinese_preparation" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>attach_money</md-icon>
                  <label>Chinese Preparation Price</label>
                  <md-input v-model="chinese_preparation" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider name="cash_payment_discount" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>%</md-icon>
                  <label>Cash Payment Discount</label>
                  <md-input v-model="cash_payment_discount" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider name="sibling_discount" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>%</md-icon>
                  <label>Sibling Discount</label>
                  <md-input v-model="sibling_discount" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="scope"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Scope</label>
                  <md-select v-model="scope" name="scope">
                    <md-option value="">Select Scope</md-option>
                    <md-option value="1">Term</md-option>
                    <md-option value="2">Yearly</md-option>
                    <md-option value="3">Full Tuition</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="education_duration"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Education Duration</label>
                  <md-select
                    v-model="education_duration"
                    name="education_duration"
                  >
                    <md-option value="">Select Education Duration</md-option>
                    <md-option value="0">1 year</md-option>
                    <md-option value="1">1.5 years</md-option>
                    <md-option value="2">2 years</md-option>
                    <md-option value="3">3 years</md-option>
                    <md-option value="4">4 years</md-option>
                    <md-option value="5">5 years</md-option>
                    <md-option value="6">6 years</md-option>
                    <md-option value="7">6+ years</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="quota"
                rules="numeric"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Quota</label>
                  <md-input v-model="quota" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="education_type"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Education Type</label>
                  <md-select v-model="education_type" name="education_type">
                    <md-option value="">Select Education Type</md-option>
                    <md-option value="1">Full time</md-option>
                    <md-option value="2">Evening Period</md-option>
                    <md-option value="3">Online</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="campus_type"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Campus Type</label>
                  <md-select v-model="campus_type" name="campus_type">
                    <md-option value="">Select Campus Type</md-option>
                    <md-option value="1">On campus</md-option>
                    <md-option value="2">Off campus</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="education_language"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Education Language</label>
                  <md-select
                    v-model="education_language"
                    name="education_language"
                  >
                    <md-option value="">Select Language</md-option>
                    <md-option value="Turkish">Turkish</md-option>
                    <md-option value="English">English</md-option>
                    <md-option value="Arabic">Arabic</md-option>
                    <md-option value="Russian">Russian</md-option>
                    <md-option value="Spanish">Spanish</md-option>
                    <md-option value="French">French</md-option>
                    <md-option value="German">German</md-option>
                    <md-option value="%30 English %70 Turkish"
                      >%30 English %70 Turkish
                    </md-option>
                    <md-option value="%50 English %50 Turkish"
                      >%50 English %50 Turkish
                    </md-option>
                    <md-option value="%30 Arabic %70 Turkish"
                      >%30 Arabic %70 Turkish
                    </md-option>
                    <md-option value="%30 German %70 Turkish"
                      >%30 German %70 Turkish
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="city" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>City</label>
                  <md-select v-model="city" name="city">
                    <md-option value="">Select City</md-option>
                    <md-option
                      v-for="c in cities"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="address" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Address</label>
                  <md-input v-model="address" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="website" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Website</label>
                  <md-input v-model="website" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div
              v-if="$store.role === 1"
              class="md-layout-item md-size-33 md-small-size-100"
            >
              <ValidationProvider name="status" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>rule</md-icon>
                  <label>Status</label>
                  <md-select v-model="status" name="status">
                    <md-option value="">Select Status</md-option>
                    <md-option value="1">Full Active</md-option>
                    <md-option value="2">Active</md-option>
                    <md-option value="3">Inactive</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="detail" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Detail</label>
                  <md-input v-model="detail" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="modules" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Modules</label>
                  <md-input v-model="modules" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="admission_and_fees"
                rules="numeric"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Admission And Fees</label>
                  <md-input v-model="admission_and_fees" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="requirements"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Admission Requirements</label>
                  <md-select
                    v-model="requirements"
                    name="requirements"
                    multiple
                  >
                    <md-option value="1"
                      >Foreign language exam results</md-option
                    >
                    <md-option value="2">Recommendation letter</md-option>
                    <md-option value="3">Research proposal</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="installments"
                rules="numeric"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Installments</label>
                  <md-input v-model="installments" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="deposit" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Deposit</label>
                  <md-input v-model="deposit" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="refund_policy"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Refund Policy</label>
                  <md-select v-model="refund_policy" name="refund_policy">
                    <md-option value="1">No Refund</md-option>
                    <md-option value="2">%25 Refund</md-option>
                    <md-option value="3">%50 Refund</md-option>
                    <md-option value="4">%75 Refund</md-option>
                    <md-option value="5">Full Refund</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-checkbox v-model="is_quota_full">Is quota full?</md-checkbox>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider name="notes" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Notes</label>
                  <md-input v-model="notes" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Program
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: "/img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      programID: null,

      cities: [],
      universities: [],

      name: null,
      university: null,
      application_autumn_start_date: null,
      application_autumn_end_date: null,
      application_spring_start_date: null,
      application_spring_end_date: null,
      lesson_start_date: null,
      type: null,
      price: null,
      discounted_price: null,
      commission: null,
      fix_commission_price: null,
      student_fix_commission_price: null,
      currency: null,
      english_preparation: null,
      turkish_preparation: null,
      german_preparation: null,
      arabic_preparation: null,
      french_preparation: null,
      russian_preparation: null,
      spanish_preparation: null,
      chinese_preparation: null,
      cash_payment_discount: null,
      sibling_discount: null,
      scope: null,
      education_duration: null,
      quota: null,
      education_type: null,
      campus_type: null,
      education_language: null,
      city: null,
      address: null,
      website: null,
      detail: null,
      modules: null,
      admission_and_fees: null,
      installments: null,
      deposit: null,
      refund_policy: null,
      is_quota_full: false,
      requirements: [],
      deadline: null,
      status: null,
      notes: null,
      extra_fields: [
          "english_preparation",
          "turkish_preparation",
          "german_preparation",
          "arabic_preparation",
          "french_preparation",
          "russian_preparation",
          "spanish_preparation",
          "chinese_preparation",
          "cash_payment_discount",
          "sibling_discount"
      ]
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.logo = files[0];
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    getExtrasField: function() {
      let extras = {}
      for (const field in this.extra_fields) {
        if (this[this.extra_fields[field]]) {
          extras[this.extra_fields[field]] = this[this.extra_fields[field]]
        }
      }
      return extras
    },
    updateUniversity() {
      let data = {
        name: this.name,
        university: this.university,
        application_autumn_start_date: this.application_autumn_start_date,
        application_autumn_end_date: this.application_autumn_end_date,
        application_spring_start_date: this.application_spring_start_date,
        application_spring_end_date: this.application_spring_end_date,
        lesson_start_date: this.lesson_start_date,
        type: this.type,
        price: this.price,
        discounted_price: this.discounted_price,
        commission: this.commission,
        fix_commission_price: this.fix_commission_price,
        student_fix_commission_price: this.student_fix_commission_price,
        currency: this.currency,
        scope: this.scope,
        education_duration: this.education_duration,
        quota: this.quota,
        education_type: this.education_type,
        campus_type: this.campus_type,
        education_language: this.$store.languages[this.education_language],
        city: this.city,
        address: this.address,
        website: this.website,
        detail: this.detail,
        modules: this.modules,
        admission_and_fees: this.admission_and_fees,
        installments: this.installments,
        deposit: this.deposit,
        refund_policy: this.refund_policy,
        is_quota_full: this.is_quota_full,
        requirements: this.requirements,
        deadline: this.deadline,
        status: this.status,
        notes: this.notes,
        extras: this.getExtrasField()
      };
      var post_data = {};
      for (const field in data) {
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          if (field === "discounted_price" && data[field] === "") {
            post_data[field] = null;
          } else {
            post_data[field] = data[field];
          }
        }
      }
      this.$store
        .updateProgram(post_data, this.programID)
        .then(response => {
          this.$notify({
            message: "Program updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.programID = this.$route.params.id;
    this.$store
      .getCities()
      .then(response => {
        this.cities = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
    this.$store
      .getUniversities({}, true)
      .then(response => {
        this.universities = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style>
.picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
